export default __webpack_public_path__ + "static/media/offiline-marker.471aa0ef.svg";